import { render, staticRenderFns } from "./ClvAccountNews.vue?vue&type=template&id=61106f7a&"
import script from "./ClvAccountNews.vue?vue&type=script&lang=js&"
export * from "./ClvAccountNews.vue?vue&type=script&lang=js&"
import style0 from "./ClvAccountNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports